module.exports = __webpack_public_path__ + "site/img/18.b1678cac.jpg";